import { render } from "./Main.vue?vue&type=template&id=583e1d1d"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=583e1d1d&lang=scss"

import exportComponent from "/Users/giovannivignone/VSCodeProjects/mintSiteAMJ-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__